module.exports = __webpack_public_path__ + "media/images/icon__locked@3x-1dff8c4d8781d8a242d6a4378614ec2d.png";